import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { IApiPathManager } from '../config/ApiPathManager';
import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { API_IDS } from '@intigral/constant';
import {
    IContentLikeDislikePayload,
    IContentLikeDislikeResponse,
    IGetContentRatingResponse,
    IGetContentRatingSearchParams,
    ILearnActionResponse,
    ILearnEventPayload,
    ISearchClickActionPayload,
    ISetPreferencesActionPayload,
    ISetPreferencesActionResponse,
} from '../../entity/interface/iLearnAction';
import { ILearnActionRepository } from '../../core/repositories/interfaces/iLearnActionRepository';

class LearnActionRepository implements ILearnActionRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    private get productKey(): string {
        return process.env['NX_PUBLIC_PRODUCT_KEY'] || 'stc-tv';
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async addLikeDislike(apiKey: string, paylod: IContentLikeDislikePayload, identityToken: string): Promise<any> {
        const response = await this.http.post<IContentLikeDislikeResponse>(
            this.apiPathManager.getPath(API_IDS.CONTENT_LIKE_DISLIKE_RATING),
            {
                params: {
                    apiKey,
                    itemGuid: paylod?.itemGuid,
                    profileName: paylod?.profileName,
                    userName: paylod?.userName,
                },
                body: {
                    ...paylod,
                },
                headers: {
                    identityToken: identityToken,
                },
            }
        );

        return response.data;
    }

    async getContentRating(
        apiKey: string,
        param: IGetContentRatingSearchParams,
        identityToken: string
    ): Promise<IGetContentRatingResponse> {
        const response = await this.http.get<IGetContentRatingResponse>(
            this.apiPathManager.getPath(API_IDS.GET_CONTENT_RATING),
            {
                params: {
                    ...param,
                    apiKey: apiKey,
                },
                headers: {
                    identityToken: identityToken,
                },
            }
        );
        return response.data;
    }

    async searchClickAction(apiKey: string, paylod: ISearchClickActionPayload, identityToken: string): Promise<any> {
        const response = await this.http.post<ILearnActionResponse>(
            this.apiPathManager.getPath(API_IDS.SEARCH_ACTION_CLICK),
            {
                params: {
                    apiKey,
                },
                body: {
                    ...paylod,
                },
                headers: {
                    identityToken: identityToken,
                },
            }
        );

        return response.data;
    }

    async learnEvent(apiKey: string, paylod: ILearnEventPayload, identityToken: string): Promise<any> {
        const response = await this.http.post<ILearnActionResponse>(this.apiPathManager.getPath(API_IDS.LEARN_EVENTS), {
            params: {
                apiKey,
            },
            body: {
                ...paylod,
            },
            headers: {
                identityToken: identityToken,
            },
        });
        return response.data;
    }

    async setPreferencesAction(
        apiKey: string,
        payload: ISetPreferencesActionPayload,
        identityToken: string,
        authToken: string,
        // Required in case of Password Protected Profile
        epochMs: string,
        encPassword: string
    ): Promise<any> {
        const response = await this.http.post<ISetPreferencesActionResponse>(
            this.apiPathManager.getPath(API_IDS.LEARN_ACTION_SET_PREFERENCES),
            {
                params: {
                    apiKey,
                },
                body: {
                    ...payload,
                },
                headers: {
                    identityToken: identityToken,
                    Authorization: authToken,
                    epochMs,
                    encPassword,
                },
            }
        );

        return response.data;
    }
}

export default LearnActionRepository;
